import { Breadcrumb } from 'components/breadcrumb'
import { PecSwitch } from 'components/route'
import { useAtendimentoIndividualViewQuery } from 'graphql/hooks.generated'
import React from 'react'
import { Route, useRouteMatch } from 'react-router'

import { FolhaRostoView } from '../detail/folha-rosto/FolhaRostoView'
import { EscutaInicialHeader } from './EscutaInicialHeader'
import { EscutaInicialMainView } from './EscutaInicialMainView'

interface EscutaInicialProps {
  atendimentoId: string
}

export function EscutaInicialView(props: EscutaInicialProps) {
  const { atendimentoId } = props

  const {
    data: { atendimento },
  } = useAtendimentoIndividualViewQuery({
    fetchPolicy: 'cache-and-network',
    variables: { atendimentoId },
  })
  const { cidadao } = atendimento || {}
  const match = useRouteMatch()

  return (
    <>
      <Breadcrumb title='Escuta Inicial' />

      <EscutaInicialHeader cidadaoId={cidadao?.id} />

      <PecSwitch>
        <Route exact path={`${match.url}`}>
          <EscutaInicialMainView atendimentoId={atendimentoId} />
        </Route>
        <Route path={`${match.url}/folha-rosto`} component={FolhaRostoView} />
      </PecSwitch>
    </>
  )
}
